import React from "react";

/**
 * FormWrapper Component
 *
 * Container matching site-wide design language with subtle green accents
 */
export default function FormWrapper({ children, showPattern = true }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fafafa",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Subtle background pattern */}
      {showPattern && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `radial-gradient(circle at 1px 1px, #e5e5e5 1px, transparent 0)`,
            backgroundSize: "40px 40px",
            opacity: 0.4,
            pointerEvents: "none",
          }}
        />
      )}

      {/* Subtle gradient accent at top - muted emerald */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "400px",
          background: "linear-gradient(180deg, rgba(54, 69, 79, 0.03) 0%, transparent 100%)",
          pointerEvents: "none",
        }}
      />

      {/* Content card - matching site card styling */}
      <div
        style={{
          maxWidth: "520px",
          width: "100%",
          padding: "48px 40px",
          margin: "24px",
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #e5e5e5",
          boxShadow: "0 4px 24px rgba(0, 0, 0, 0.04)",
          position: "relative",
          zIndex: 1,
        }}
      >
        {children}
      </div>

      {/* Animations */}
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.7;
            }
          }

          @keyframes scaleIn {
            from {
              transform: scale(0.9);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }

          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
}
